export const name = '_tetherusd'
export const displayName = 'Tether USD'
export const ticker = `${name}_USDT`
export const displayTicker = 'USDT'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 8,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = [
  'tetherusd',
  'tetherusd_tron',
  'tetherusd_algorand',
  'tetherusd_solana',
  'usdt_avalanchec_d80c1afa',
  'usdt_matic_86e249c1',
  'usdt_bsc_ddedf0f8',
  'tetherusd_goerli',
  'tetherusd_tezos',
  'usdt_ethereumarbone_efa95268',
  'usdt_optimism_26487766',
]
